import * as z from 'zod';

export const modalWithoutSchema = z.object({
  name: z.string().nonempty('O campo Nome Tópico é obrigatório.'),
});
